import React, { useCallback, useEffect } from 'react'
import { Button, Col, message, Row, Spin, Typography } from 'antd'
import './MyTaxApp.css'
import {
  useMutateConfirmMyTaxStatus,
  useMutateConfirmMyTaxBind,
  useMutateCreateMyTaxStatus,
  useMutateSendMyTaxBind
} from '../../../api/react-query/partners'
import { AppConfig } from '../../../AppConfig'
import { useStores } from '../../../Store/Store'
import ActiveSelfEmployedStatus from '../SelfEmployedStatus/ActiveSelfEmployedStatus'
import InActiveSelfEmployedStatus from '../SelfEmployedStatus/InActiveSelfEmployedStatus'

const { Title } = Typography
const { smzStatusCodes, smzErrorCodes, smzRequiredActions } = AppConfig

function MyTaxApp ({ profile }) {
  const { partnerProfile } = useStores()

  const {
    data: dataCreateTaxStatus,
    mutate: createTaxStatus,
    isSuccess: isSuccessCreateTaxStatus,
    isError: isErrorCreateTaxStatus,
    isLoading: isLoadingCreateTaxStatus
  } = useMutateCreateMyTaxStatus()

  const {
    data: dataTaxStatus,
    mutate: confirmTaxStatus,
    isSuccess: isSuccessTaxStatus,
    isError: isErrorTaxStatus,
    isLoading: isLoadingTaxStatus
  } = useMutateConfirmMyTaxStatus()

  const {
    data: dataTaxBind,
    mutate: confirmTaxBind,
    isSuccess: isSuccessTaxBind,
    isError: isErrorTaxBind,
    isLoading: isLoadingTaxBind
  } = useMutateConfirmMyTaxBind()

  const {
    data: dataSendTaxBind,
    mutate: sendTaxBind,
    isSuccess: isSuccessSendTaxBind,
    isError: isErrorSendTaxBind,
    isLoading: isLoadingSendTaxBind
  } = useMutateSendMyTaxBind()

  useEffect(() => {
    if (isSuccessCreateTaxStatus && dataCreateTaxStatus?.isSuccess) {
      message.success('Запрос отправлен')
      partnerProfile.setPartnerProfile(dataCreateTaxStatus?.partner)
    } else if (isErrorCreateTaxStatus || dataCreateTaxStatus?.errorMessage) {
      message.error(dataCreateTaxStatus?.errorMessage || 'Ошибка запроса')
    }
  }, [isSuccessCreateTaxStatus, isErrorCreateTaxStatus, dataCreateTaxStatus])

  useEffect(() => {
    if (isSuccessTaxStatus && dataTaxStatus?.isSuccess) {
      message.success('Запрос отправлен')
      if (
        dataTaxStatus?.partner?.profile?.smz?.requiredAction === profile?.smz?.requiredAction &&
        dataTaxStatus?.partner?.profile?.smz?.errorCode === profile?.smz?.errorCode
      ) {
        showMessageError({
          requiredAction: dataTaxStatus?.partner?.profile?.smz?.requiredAction,
          errorCode: dataTaxStatus?.partner?.profile?.smz?.errorCode
        })
      }
      partnerProfile.setPartnerProfile(dataTaxStatus?.partner)
    } else if (isErrorTaxStatus || dataTaxStatus?.errorMessage) {
      message.error(dataTaxStatus?.errorMessage || 'Ошибка запроса проверки статуса')
    }
  }, [isSuccessTaxStatus, isErrorTaxStatus, dataTaxStatus])

  useEffect(() => {
    if (isSuccessTaxBind && dataTaxBind?.isSuccess) {
      if (!dataTaxBind?.partner?.profile?.smz?.errorCode !== smzErrorCodes.requestNotProcessed) {
        message.success('Запрос отправлен')
      }
      partnerProfile.setPartnerProfile(dataTaxBind?.partner)
    } else if (isErrorTaxBind || dataTaxBind?.errorMessage) {
      message.error(dataTaxBind?.errorMessage || 'Ошибка запроса подтверждения партнерства')
    }
  }, [isSuccessTaxBind, isErrorTaxBind, dataTaxBind])

  useEffect(() => {
    if (isSuccessSendTaxBind && dataSendTaxBind?.isSuccess) {
      message.success('Запрос отправлен')
      partnerProfile.setPartnerProfile(dataSendTaxBind?.partner)
    } else if (isErrorSendTaxBind || dataSendTaxBind?.errorMessage) {
      message.error(dataSendTaxBind?.errorMessage || 'Ошибка запроса')
    }
  }, [isSuccessSendTaxBind, isErrorSendTaxBind, dataSendTaxBind])

  useEffect(() => {
    if (profile?.smz?.errorCode === smzErrorCodes.requestNotProcessed) {
      message.error({
        content: (
          <>
            <b>Партнерство не получено</b><br />
            Партнер еще не передал права в моем налоге
          </>
        ),
        duration: 5
      })
    }
    if (profile?.smz?.errorCode === smzErrorCodes.invalidInn) {
      message.error('ИНН невалиден', 5)
    }
  }, [profile?.smz?.errorCode])

  useEffect(() => {
    showMessageError({
      requiredAction: profile?.smz?.requiredAction, errorCode: profile?.smz?.errorCode
    })
  }, [profile?.smz?.errorCode, profile?.smz?.requiredAction])

  const showMessageError = ({ requiredAction, errorCode }) => {
    if (requiredAction === smzRequiredActions.ConfirmSmz && [
      smzErrorCodes.unregistered,
      smzErrorCodes.partnerUnregistered
    ].includes(errorCode)
    ) {
      message.error({
        content: (
          <>
            <b>Вы пока не встали на учет в качестве самозанятого</b><br />
            Пожалуйста перейдите в приложении «Мой налог» и выполните шаги согласно инструкции
          </>
        ),
        duration: 5
      })
    }
  }

  const handleConfirmStatus = () => {
    confirmTaxStatus()
  }

  const handleConfirmBind = () => {
    confirmTaxBind()
  }

  const handleReload = useCallback(() => {
    if (profile?.smz?.requiredAction === smzRequiredActions.SendCreate) {
      createTaxStatus()
    } else if (profile?.smz?.requiredAction === smzRequiredActions.ConfirmSmz) {
      confirmTaxStatus()
    } else if (profile?.smz?.requiredAction === smzRequiredActions.SendBind) {
      sendTaxBind()
    } else if (profile?.smz?.requiredAction === smzRequiredActions.ConfirmBind) {
      confirmTaxBind()
    } else {
      location.reload()
    }
  }, [profile?.smz?.requiredAction])

  const getContentError = (errorCode) => {
    return (
      <Row justify='space-between' className='myTax-error'>
        {
          errorCode === smzErrorCodes.fnsError
            ? (
              <>
                <Col span={24}>
                  <Title level={3}>Не удалось получить данные</Title>
                  <p>Нет ответа ФНС</p>
                  <p>Иногда данные задерживаются<br />вернитесь чуть позже</p>
                </Col>
                <Col span={24}>
                  <img src='/img/alert-yellow.png' className='alert' />
                </Col>
              </>
            )
            : (
              <>
                <Col span={24}>
                  <Title level={3}>Не удалось получить данные</Title>
                  {/* <Title level={3}>Ошибка</Title> */}
                  <p>Налоговая не отвечает.<br />Попробуйте позже</p>
                </Col>
                <Col span={24}>
                  <img src='/img/alert-yellow.png' className='alert' />
                </Col>
              </>
            )
        }
        <Col span={24} className='btn-block'>
          <Button
            block
            ghost
            size='large'
            type='primary'
            className='margin-bottom-20'
            loading={isLoadingCreateTaxStatus || isLoadingSendTaxBind}
            onClick={handleReload}
          >
            Обновить
          </Button>
        </Col>
      </Row>
    )
  }

  if (isLoadingTaxBind || isLoadingTaxStatus || isLoadingCreateTaxStatus || isLoadingSendTaxBind) {
    return <Spin style={{ marginTop: '1rem', width: '100%' }} size='large' />
  }

  if (profile?.smz?.errorCode && ![
    smzErrorCodes.partnerUnregistered,
    smzErrorCodes.requestNotProcessed
  ].includes(profile?.smz?.errorCode)) {
    return getContentError(profile?.smz?.errorCode)
  }

  return (
    <div className='myTaxApp'>
      {profile?.smz?.requiredAction === smzRequiredActions.ConfirmSmz && (
        <ActiveSelfEmployedStatus onClick={handleConfirmStatus} loading={isLoadingTaxStatus} />
      )}
      {
        (
          profile?.smz?.statusCode === smzStatusCodes.bindingSending ||
          [smzRequiredActions.ReaffirmBind, smzRequiredActions.ConfirmBind].includes(profile?.smz?.requiredAction)
        ) && (
          <InActiveSelfEmployedStatus onClick={handleConfirmBind} loading={isLoadingTaxBind} />
        )
      }
    </div>
  )
}

export default MyTaxApp
